<div class="overview-panel" [ngClass]="{'overview-hidden': isOverviewActive}">
    <div class="overview-inner">
        <div class="d-flex justify-content-between align-items-center">
            <h4 class="fw-4">{{MODELS_OVERVIEW}}</h4>
            <button mat-button (click)="close()">{{CLOSE}}</button>
        </div>
        <!-- <div class="d-flex flex-row mb-2">
            <mat-form-field appearance="fill" class="flex-grow-1 me-2 mt-1">
                <input matInput [formControl]="searchBox" placeholder="Name" (keyup.enter)="getModels()">
            </mat-form-field>
            <button mat-fab (click)="getModels()">
                @if(!isLoading){
                    <mat-icon>search</mat-icon>
                }@else{
                    <mat-progress-spinner class="small-spinner bright-spinner" mode="indeterminate"></mat-progress-spinner>
                }
            </button>
        </div> -->
        @if (!isLoading) {
            <models-tree [menu]="menu" [onModelSelected]="onModelSelected" [edit_mode]="false"></models-tree>          
        }@else {
            <div class="h-100 d-flex justify-content-center align-items-center loading">
                <mat-progress-spinner mode="indeterminate" class="bright-spinner"> </mat-progress-spinner>
            </div>
        }
    </div>
</div>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="onRestore('IMPORT_IN_VIEW')" [disabled]="isSameDataService()">{{RESTORE_HERE}}</button>
  <button mat-menu-item (click)="onRestore('IMPORT_NEW_TAB')">{{RESTORE_NEW_TAB}}</button>
</mat-menu>
